import { useTranslation } from "react-i18next";
import "./About.css";

function About() {
  const { t } = useTranslation();

  return (
    <section className="about" id="about">

      <div className="about-container">


        {/* ================= IMAGE ================= */}

        <div className="about-image-wrapper">

          <div className="about-image">

            <img
              src="https://i.postimg.cc/t4jRbyhv/Whats-App-Image-2026-08-18-at-3-19-22-PM.jpg"
              alt="Wedding Photography"
            />

          </div>

          <div className="about-frame"></div>

        </div>


        {/* ================= CONTENT ================= */}

        <div className="about-content">


          {/* Label */}

          <span className="about-label">
            {t("about.label")}
          </span>


          {/* Title */}

          <h2>

            {t("about.title1")}

            <br />

            <span>
              {t("about.title2")}
            </span>

          </h2>


          {/* Divider */}
{/* 
          <div className="about-line">

            <span></span>

            <i>✦</i>

            <span></span>

          </div> */}


          {/* Text */}

          <p>
            {t("about.text1")}
          </p>

          <p>
            {t("about.text2")}
          </p>

          <p>
            {t("about.text3")}
          </p>

          <p>
            {t("about.text4")}
          </p>


          {/* Button */}

          {/* <a
            href="#contact"
            className="about-button"
          >
            {t("about.button")}

            <span>↗</span>

          </a> */}

        </div>

      </div>

    </section>
  );
}

export default About;